<p-toast position="bottom-right"></p-toast>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-row mt-3">
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="iVariable" class="form-control" 
                [placeholder]="'Ingrese variable'">
            <label>Variable</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="sDescripcion" class="form-control"
                [placeholder]="'Ingrese descripción'">
            <label>Descripción</label>
        </div>
        <div class="form-field flex-grow-1">
            <p-dropdown
                [options]="variables"
                formControlName="variableSeleccionada"
                [placeholder]="'Seleccione una variable'"
                [loading]="loadingVariables"
                [filter]="true"
                appendTo="body"
                optionLabel="label"
                optionValue="value"
                [style]="{ width: '100%' }">
            </p-dropdown>
            <label>Variable (Desplegable)</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" (click)="onSubmit()"
            [disabled]="loading">
            <mat-icon>save</mat-icon>
            {{ model ? 'Actualizar' : 'Guardar' }}
        </button>
    </div>
</form>